import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IAddress } from 'src/app/shared/services/address.service';
//import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import { IPrepayReservation } from 'src/app/shared/services/reservation.service';
import { ICustomerTransactionEmailInfo, IDisplayTaxes } from '../receipt/receipt.component';

export interface ICustomerReservationTransactionEmail {
  isBlockedCard: boolean;
  isBlockedEmail: boolean;
  errorMessage: string;
  brandName: string;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  ghostedPaymentNumber: string;
  reservationNumber: number;
  reservationDate: Date;
  createdDate: Date;
  storeName: string;
  invoiceNumber: string;
  recipientDetail: string;
  total: number;
  subtotal: number;
  tip: number;  
  storeAddress: IAddress;
  note: string;
  totalPrice: number;
  prepayReservation: IPrepayReservation;
  reservation: IEmailReservation;
  info: ICustomerTransactionEmailInfo;
  translations: { [key: string]: string };
  reservedTime: string;
  storePhone: string;
  onlyGiftCard: boolean;
  useGiftCard: boolean;
  creditCardAmount: number;
  giftCardAmount: number;
  billingAddress: string;
  ghostedGiftCardNumber: string;
  taxes: IDisplayTaxes[];
  gainedReward: boolean;
  ghostedRewardCard?: string;
  gainedPoint?: number;
  pointBalance?: number;
  logoUrl?: string;
  logoFileName?: string;
  rebateAmount: string;
  isRebateApplied:boolean;
  isDoorDashDrive:boolean;
  convenienceFee: number;
}

export interface IEmailReservation{
    specialRequest: string;
    packages: IEmailReservationSectionPackage[];
}

export interface IEmailReservationSectionPackage{
    id: string;
    name: string;
    totalPrice: string;
    quantity: number;
    specialRequest: string;
    price?: number;
}

@Component({
    selector: 'reservation-receipt',
    templateUrl: './reservation-receipt.component.html',
    styleUrls: ['./reservation-receipt.component.scss'],
    standalone: false
})
export class ReservationReceiptComponent implements OnInit {
  title: string = 'Nav.Receipt';

  moment: any = moment;

  @Input() customerReservationTransactionEmail : ICustomerReservationTransactionEmail;

  constructor(
    private modalCtrl: ModalController,
    //public translateService: TranslateService
  
    ) {
  }

  ngOnInit() {
    localStorage.removeItem('ReservationStoreId');
  }

  async cancel() {
    await this.modalCtrl.dismiss(null);
  }

  formatAddress(address: IAddress) {
    return `${address.streetNumber} ${address.suiteNumber != null ? address.suiteNumber : ""} 
    ${address.streetType} ${address.street} ${address.streetDirection != null ? address.streetDirection : ""}
    ${address.city} ${address.postalCode}`;
  }
}
